import { css, html } from "lit";
import { property, query, customElement } from "lit/decorators.js";
import { Style } from "./Styles";
import { BaseElement } from "./BaseElement";
import SlDialog from "@shoelace-style/shoelace/dist/components/dialog/dialog";
import { makeCustomEvent } from "../Utils";

@customElement("ds-entry-dialog")
export class EntryDialog extends BaseElement {
    static override styles = [Style, css``];

    @property({ type: Boolean }) open = false;
    @property({ type: String }) label = "";
    @property({ type: Boolean }) noHeader: any;
    @property({ type: Boolean }) isValid = false;
    @property({ type: String }) acceptText = "Accept";
    @property({ type: String }) cancelText = "Cancel";

    @query("#dialog") _dialog: SlDialog | undefined;

    public show() {
        this._dialog?.show();
    }

    private hide() {
        this._dialog?.hide();
    }

    protected override firstUpdated(): void {
        if (this.open) {
            this.show();
        }
    }
    protected cancel() {
        this.dispatchEvent(
            new CustomEvent("on-cancel", {
                bubbles: true,
                composed: true,
                detail: {},
            })
        );
        this.hide();
    }

    override render() {
        return html`<sl-dialog id="dialog" label="${this.label}" ?no-header=${this.noHeader}>
            <slot></slot>
            <div slot="footer">
                <sl-button variant="default" @click=${() => this.cancel()}
                    >${this.cancelText}</sl-button
                >
                <sl-button
                    variant="success"
                    ?disabled=${!this.isValid}
                    @click=${() => {
                        this.dispatchEvent(makeCustomEvent("on-accept"));
                        this.hide();
                    }}
                >
                    ${this.acceptText}</sl-button
                >
            </div>
        </sl-dialog>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-entry-dialog": EntryDialog;
    }
}
